/*
 * @Author: lzz
 * @Date: 2024-06-09 12:40:26
 * @LastEditTime: 2024-07-23 23:48:56
 */
const TokenKey = 'Admin-Token'
export function getToken() {
  let _token = localStorage.getItem("token")
  return _token;
  // return localStorage.getItem(TokenKey);
  //return Cookies.get(TokenKey)
}

export function setToken(token) {
  localStorage.setItem(TokenKey, token);
  return true;
  //return Cookies.set(TokenKey, token)
}

export function removeToken() {
  localStorage.removeItem(TokenKey);
  return true;
  //return Cookies.remove(TokenKey)
}
